import { css } from 'styled-components';

export const styles = css`
  background: ${p => p.theme.token('background-pattern')};
  color: ${p => p.theme.token('text-active')};
  box-shadow: ${Styles.boxShadow};
`;
